import angular from 'angular';
import editCustomerSectionComponent from './editCustomerSection.component';

let editCustomerSectionModule = angular.module('editCustomerSection', []).component('editCustomerSection', editCustomerSectionComponent);

export default editCustomerSectionModule;



// WEBPACK FOOTER //
// ./app/components/editCustomerSection/editCustomerSection.js